import React, { useState, useEffect} from 'react'
import { SyncLoader } from 'react-spinners'

const Loading = (props) => {
    const [isMounted, setIsMounted] = useState(false);
    const [hide, setHide] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    useEffect(() => {
        if(props.show) {
            setHide(false);
        } else {
            setTimeout(() => {
                setHide(true);
            }, 300);
        }
    }, [props.show]);

    return (
        <div className={'z-10 fixed top-0 start-0 w-full h-full bg-gray-50 transition-opacity duration-300 ' + (isMounted ? (props.show ? 'opacity-100' : 'opacity-0') : 'opacity-0')} style={{ display: !hide ? 'block' : 'none' }}>
            <div className='text-center mt-64'>
                <SyncLoader color="#a855f7" size="24px" />
                <div className='text-gray-600 my-8'>{props.text}</div>
            </div>
        </div>
    )
}

export default Loading